import axios from 'axios';
import moment from 'moment';
import React, { useMemo, useState } from 'react'
import { environment } from '../../env';
import Table from '../Table';
import PriceFormater from '../../Helper/PriceFormater';

function PropertiesDetails({ name, id, propDate, subGala, agree_str, agree_end, area, percentage, buildingNumber, currentTenant, rentAmount, rentDate, gala, propertyArea, purchaseFrom, possession, purchaseDate, broker_name }) {

    const [yearsBetween, setYearsBetween] = useState(0);
    const [monthsBetween, setMonthsBetween] = useState(0);
    const [daysBetween, setDaysBetween] = useState(0);
    const [annaulrent, setAnnualrent] = useState();


    const CalculateDate = () => {
        const currentDate = moment(agree_end).format('YYYY-MM-DD');
        const CompleteDate = moment(agree_str).format('YYYY-MM-DD')
        var date1 = moment(currentDate).add('days', 1);
        var date2 = moment(CompleteDate);
        let years = date1.diff(date2, 'year');
        date2.add(years, 'years');
        let months = date1.diff(date2, 'months');
        date2.add(months, 'months');
        let days = date1.diff(date2, 'days');
        date2.add(days, 'days');
        setYearsBetween(years);
        setMonthsBetween(months);
        setDaysBetween(days);
    }

    const getTenant = (data) => {
        try {
            axios.get(`${environment.baseUrl}tenant-rentannual/${data}`).then(res => {
                res.data.map((data, i) => {
                    data.srno = i + 1;
                })
                setAnnualrent(res.data)
            }).catch(res => {
                setAnnualrent([])
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };
    const colums = [
        {
            name: "Sr No",
            selector: (row) => row?.srno,
            sortable: true,
            style: {
              fontSize: "2.6rem",
            },
          },
          {
            name: "Start Date",
            selector: (row) => moment(row?.start_date).format("DD-MM-YYYY"),
            sortable: true,
            style: {
              fontSize: "2.6rem",
            },
          },
          {
            name: "End Data",
            selector: (row) => moment(row?.end_date).format("DD-MM-YYYY"),
            sortable: true,
            style: {
              fontSize: "2.6rem",
            },
          },
          {
            name: "Rent ₹",
            selector: (row) => <PriceFormater price={row.rent} />,
            sortable: true,
            style: {
              fontSize: "2.6rem",
            },
          },
          {
            name: "Inc %",
            selector: (row) => `${row?.rent_increment} %`,
            sortable: true,
            style: {
              fontSize: "2.3rem",
            },
          },
          {
            name: "Inc ₹",
            selector: (row) => <PriceFormater price={row.rent_incrementamt} />,
            sortable: true,
            style: {
              fontSize: "2.3rem",
            },
          },
          // {
          //   name: "Rent/sq",
          //   selector: (row) => (
          //     <PriceFormater
          //       price={row?.rent * Number(row?.proposal?.required_area)}
          //     />
          //   ),
          //   sortable: true,
          //   style: {
          //     fontSize: "2.3rem",
          //   },
          // },
          {
            name: "Total Amount",
            selector: (row) => (
              <PriceFormater
                price={row?.rent * Number(area)}
              />
            ),
            sortable: true,
            style: {
              fontSize: "2.3rem",
            },
          },
    ];


    useMemo(() => {
        CalculateDate();
        getTenant(id);
    }, [agree_str])

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center'>
                <h1 className='title-font-bold '>DETAILS</h1>
            </div>
            <div className="card w-100 border-0 border-radius-15">
                <div className="row g-0 border-bottom pb-4 text-start text-sm-start text-md-start text-lg-start text-xl-start">
                    <div className="col-12 col-lg-4 col-md-6  col-sm-6 col-xl-4   col-lg-6 mt-3">
                        <div className="card-body">
                            <h5 className='fs-2 base-font-700 text-base-color mb-3'>INVESTOR DETAILS</h5>
                            <h5 className="fs-3 base-font-700 mb-4">Name: <span className='fs-3 base-font-400'>{name}</span> </h5>
                            {/* <h5 className="fs-3 base-font-700 mb-4 ">Purchase From: <span className='fs-3 base-font-400'></span> </h5> */}
                            <h5 className="fs-3 base-font-700 mb-4">Purchase Date:<span className='fs-3 base-font-400'> {moment(purchaseDate).format("DD/MM/YYYY")}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Age of Property:<span className='fs-3 base-font-400'> {moment(propDate).format("DD/MM/YYYY")}</span> </h5>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 col-md-6  col-sm-6 col-xl-4   col-lg-6 mt-3">
                        <div className="card-body">
                            <h5 className='fs-2 base-font-700 text-base-color mb-3'>BUILDING DETAILS</h5>
                            <h5 className="fs-3 base-font-700 mb-4">Building No: <span className='fs-3 base-font-400'>{buildingNumber}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4 ">Gala:<span className='fs-3 base-font-400'>{gala}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4 ">Sub Gala:<span className='fs-3 base-font-400'>{subGala}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Area: <span className='fs-3 base-font-400'>{area} sqft</span> </h5>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 col-md-12  col-sm-6 col-xl-4   col-lg-12 mt-3">
                        <div className="card-body">
                            <h5 className='fs-2 base-font-700 text-base-color mb-3'>TENANT DETAILS</h5>
                            <h5 className="fs-3 base-font-700 mb-4">Current Tenant: <span className='fs-3 base-font-400'>{currentTenant}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Agreement Date: <span className='fs-3 base-font-400'>{moment(agree_str).format("DD/MM/YYYY")}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Agreement End Date: <span className='fs-3 base-font-400'>{moment(agree_end).format("DD/MM/YYYY")}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Possession Date:<span className='fs-3 base-font-400'> {moment(possession).format("DD/MM/YYYY")}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4 ">Rent Date: <span className='fs-3 base-font-400'>{moment(rentDate).format("DD/MM/YYYY")}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Agreement Duration: <span className='fs-3 base-font-400'>   {`${yearsBetween} years, ${monthsBetween} months, ${daysBetween} days`}</span> </h5>
                            {/* <h5 className="fs-3 base-font-700 mb-4">Increment:<span className='fs-3 base-font-400'> { }</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Current Rate:<span className='fs-3 base-font-400'> { }</span> </h5> */}
                            <h5 className="fs-3 base-font-700 mb-4">Tenant Deposit: <span className='fs-3 base-font-400'>{percentage}</span> </h5>
                            <h5 className="fs-3 base-font-700 mb-4">Brokage: <span className='fs-3 base-font-400'>{ broker_name == 'null' || broker_name == null ? 'NA' : broker_name }</span> </h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white px-2 pb-2 rounded-5 shadow-sm">
                <div className="pt-3">
                    <h1 className='fs-2 title-font-700 ms-4 my-3 text-dark'>Annual Rent</h1>
                    <Table columns={colums} data={annaulrent} />
                </div>
            </div>
        </div>
    )
}

export default PropertiesDetails